import { Loader } from '@googlemaps/js-api-loader';

const apiKey = import.meta.env.VITE_GOOGLE_MAP_API_KEY;
let loader: Loader | null = null;
let isInitialized = false;
let initPromise: Promise<{ places: any; geocoding: any }> | null = null;

export async function initGoogleMaps(): Promise<{ places: any; geocoding: any }> {
	if (isInitialized) {
		return initPromise!;
	}
	if (initPromise) {
		return initPromise;
	}

	initPromise = (async () => {
		loader = new Loader({
			apiKey,
			version: 'weekly',
		});

		// Import libraries and return them directly
		const [places, geocoding] = await Promise.all([
			loader.importLibrary('places'),
			loader.importLibrary('geocoding'),
		]);

		// Verify global namespace is properly initialized
		if (!window.google?.maps) {
			throw new Error('Google Maps API global namespace not initialized');
		}

		isInitialized = true;
		return { places, geocoding };
	})();

	return initPromise;
}

export function getGoogleMapsLoader() {
	if (!loader) {
		throw new Error('Google Maps loader not initialized. try');
	}
	return loader;
}
